module.exports = __webpack_public_path__ + "static/img/xiaoyisi2.8bf7fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/xiaoyisi2.png
// module id = +t98
// module chunks = 54